/*
 * TAYR — Écran locké : compte à rebours en temps réel.
 * Lit la date cible dans [data-tayr-countdown][data-launch] et met à jour
 * les jours / heures / minutes chaque seconde.
 */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  var cd = document.querySelector('[data-tayr-countdown]');
  if (!cd) return;

  var target = new Date(cd.getAttribute('data-launch')).getTime();
  var elDays = cd.querySelector('[data-cd="days"]');
  var elHours = cd.querySelector('[data-cd="hours"]');
  var elMinutes = cd.querySelector('[data-cd="minutes"]');

  function tick() {
    var dist = target - Date.now();
    if (dist <= 0) {
      dist = 0;
      cd.classList.add('is-finished');
    }
    var days = Math.floor(dist / 86400000);
    var hours = Math.floor((dist % 86400000) / 3600000);
    var minutes = Math.floor((dist % 3600000) / 60000);
    if (elDays) elDays.textContent = days;
    if (elHours) elHours.textContent = pad(hours);
    if (elMinutes) elMinutes.textContent = pad(minutes);
  }

  tick();
  setInterval(tick, 1000);
})();

/*
 * TAYR — Inscription VIP par SMS via Klaviyo.
 *
 * - Champ téléphone enrichi par intl-tel-input (drapeau + indicatif, validation
 *   par pays, numéro normalisé en E.164 : +33612345678).
 * - À l'envoi : on intercepte (pas de POST Shopify, donc pas de rechargement →
 *   le logo 3D reste affiché), on valide, puis on inscrit le numéro à la liste
 *   Klaviyo via son API publique côté navigateur. Sur succès → pop-up de confirmation.
 *
 * Clé publique Klaviyo + ID de liste : lus sur le champ (data-klaviyo-key / -list),
 * eux-mêmes alimentés par les réglages de la section.
 */
(function () {
  var form = document.querySelector('.tayr-lock__form');
  if (!form) return;

  var input = form.querySelector('[data-phone-input]');
  var error = form.querySelector('[data-phone-error]');
  if (!input) return;

  var klaviyoKey = input.getAttribute('data-klaviyo-key');
  var klaviyoList = input.getAttribute('data-klaviyo-list');

  // intl-tel-input (drapeau + validation) si la librairie CDN est chargée
  var iti = null;
  if (typeof window.intlTelInput === 'function') {
    iti = window.intlTelInput(input, {
      initialCountry: 'fr',
      preferredCountries: ['fr', 'be', 'ch', 'lu'],
      separateDialCode: true,
      useFullscreenPopup: false,
      utilsScript:
        'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
    });

    // Raccourcit les noms du menu : retire le nom natif final entre parenthèses
    Array.prototype.forEach.call(
      document.querySelectorAll('.iti__country-name'),
      function (el) {
        el.textContent = el.textContent.replace(/\s*\([^()]*\)\s*$/, '');
      }
    );
  }

  function showError() { if (error) error.hidden = false; }
  function hideError() { if (error) error.hidden = true; }
  function openSuccess() {
    var p = document.querySelector('[data-success-popup]');
    if (p) {
      p.classList.add('is-open');
      p.setAttribute('aria-hidden', 'false');
    }
  }

  input.addEventListener('input', hideError);

  form.addEventListener('submit', function (e) {
    e.preventDefault(); // on gère l'envoi nous-mêmes (Klaviyo) — pas de rechargement

    // Récupère le numéro au format E.164 (+33…). Validation SOUPLE.
    var phone = '';
    try {
      if (iti && typeof iti.getNumber === 'function') phone = iti.getNumber() || '';
    } catch (err) { phone = ''; }

    // Si pas en E.164 (lib de validation non chargée), on le reconstruit à partir
    // de l'indicatif du pays sélectionné + le numéro tapé (sans le 0 initial).
    if (!phone || phone.charAt(0) !== '+') {
      try {
        var cc = iti.getSelectedCountryData().dialCode;
        var nat = (input.value || '').replace(/[^0-9]/g, '').replace(/^0+/, '');
        if (cc && nat) phone = '+' + cc + nat;
      } catch (e2) {}
    }
    if (!phone) phone = (input.value || '').trim();

    var digits = phone.replace(/[^0-9]/g, '');
    if (digits.length < 6) { showError(); input.focus(); return; }
    hideError();

    // Confirmation affichée tout de suite (l'inscription est prise en compte)
    openSuccess();

    var btn = form.querySelector('.tayr-lock__join');
    if (btn) btn.disabled = true;

    // Envoi à Klaviyo en arrière-plan (n'empêche jamais le pop-up).
    if (klaviyoKey && klaviyoList) {
      var headers = { 'Content-Type': 'application/json', revision: '2024-10-15' };

      // 1) Collecte GARANTIE : enregistre le numéro en profil (marche SANS SMS activé).
      fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ data: { type: 'profile', attributes: { phone_number: phone, properties: { tayr_signup: 'coming-soon' } } } })
      })
        .then(function (r) {
          if (r.ok) console.info('[TAYR] Numéro enregistré dans Klaviyo ✓ (' + phone + ')');
          else r.text().then(function (t) { console.error('[TAYR] Échec enregistrement (HTTP ' + r.status + ') :', t); });
        })
        .catch(function (err) { console.error('[TAYR] Klaviyo — erreur réseau :', err); })
        .finally(function () { if (btn) setTimeout(function () { btn.disabled = false; }, 800); });

      // 2) EN PLUS : abonnement à la liste SMS (réussira une fois le SMS activé).
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'TAYR — coming soon',
              profile: { data: { type: 'profile', attributes: { phone_number: phone } } }
            },
            relationships: { list: { data: { type: 'list', id: klaviyoList } } }
          }
        })
      })
        .then(function (res) {
          if (res.ok) console.info('[TAYR] Abonné à la liste SMS ✓');
          else console.warn('[TAYR] Liste SMS pas encore active (HTTP ' + res.status + ') — normal tant que le SMS n\'est pas activé. Le numéro est quand même collecté.');
        })
        .catch(function () {});
    } else {
      console.warn('[TAYR] Klaviyo non configuré (clé/liste manquante).');
      if (btn) btn.disabled = false;
    }

    form.reset();
  });
})();

/*
 * TAYR — Pop-up de confirmation d'inscription.
 *
 * Il s'ouvre tout seul (classe is-open posée côté serveur) après un envoi réussi
 * du formulaire. Ici on gère juste la fermeture (bouton / clic dehors / Échap).
 * Aperçu en dev : ouvrir l'URL avec #preview-success force l'affichage.
 */
(function () {
  var popup = document.querySelector('[data-success-popup]');
  if (!popup) return;

  function open() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
  }
  function close() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  // Déjà ouvert au chargement (inscription réussie) -> synchronise l'accessibilité
  if (popup.classList.contains('is-open')) popup.setAttribute('aria-hidden', 'false');

  // Aperçu du design en dev sans soumettre le formulaire (au chargement…)
  if (window.location.hash === '#preview-success') open();
  // …et aussi si on ajoute le hash sur une page déjà ouverte (pas de rechargement)
  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#preview-success') open();
  });

  var closeBtn = popup.querySelector('[data-popup-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  // Clic sur le fond (hors carte) ferme le pop-up
  popup.addEventListener('click', function (e) {
    if (e.target === popup) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

/*
 * TAYR — Animation de fermeture de "store access".
 *
 * Un <details> natif se ferme instantanément. On intercepte le clic de fermeture
 * pour jouer l'animation inverse (tayr-admin-out) avant de réellement fermer.
 * L'ouverture, elle, reste gérée par le CSS ([open] -> tayr-admin-in).
 */
(function () {
  var details = document.querySelector('.tayr-lock__admin');
  if (!details) return;
  var summary = details.querySelector('summary');
  var row = details.querySelector('.tayr-lock__admin-row');
  if (!summary || !row) return;

  // Respecte la préférence "réduire les animations" : fermeture instantanée
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var closing = false;

  summary.addEventListener('click', function (e) {
    if (!details.open || reduce) return; // ouverture : comportement natif + CSS
    // fermeture : on anime d'abord, on ferme ensuite
    e.preventDefault();
    if (closing) return;
    closing = true;
    row.style.animation = 'tayr-admin-out 0.3s ease forwards';
    row.addEventListener('animationend', function handler() {
      details.open = false;
      row.style.animation = '';
      closing = false;
      row.removeEventListener('animationend', handler);
    });
  });
})();
